import { render, staticRenderFns } from "./RegistryDevPage.vue?vue&type=template&id=0e39d9e4&"
import script from "./RegistryDevPage.vue?vue&type=script&lang=js&"
export * from "./RegistryDevPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports